import React from "react";
import * as S from "./Header.styles";
import Logo from "../../assets/images/logoConsorcio.png";

const Header = () => {
  return (
    <S.Header>
      <S.Logo>
        <img src={Logo} alt="app de vendas" />
      </S.Logo>
      <S.Title>
        <p>Portal Caixa Consórcio</p>
      </S.Title>
    </S.Header>
  );
};

export default Header;
